import { ColumnState } from "ag-grid-community";

export interface LocalGridStatus {
    rows: number
    cols?: ColumnState[],
}

/**
 * Saves the current grid state.
 * The uniqueness must be ensured by each stream individually. The suggestion is following the format "<StreamSuffix>-<TableName>".
 *
 * @param uniqueId the unique id of the table.
 * @param gridState the object containing cols state and rows amount.
 */
export function setLocalGridState(uniqueId: string, gridState: LocalGridStatus) {
    let key = `grid.${uniqueId}`;
    let value = JSON.stringify(gridState);
    localStorage.setItem(key, value);
}

/**
 * Gets the state of a specific table from the local storage if any.
 *
 * @param uniqueId the unique id of the table.
 * @return saved grid state if any, an object with just rows set to 10 otherwise.
 */
export function getLocalGridState(uniqueId: string): LocalGridStatus {
    let key = `grid.${uniqueId}`;
    let value = localStorage.getItem(key);

    return value !== null ? JSON.parse(value) : { rows: 10 };
}